import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { formatDollars } from '../../../helpers/utilityFunctions';

interface TransactionsTotalsProps {
  total: number;
}

export const AmountPaidTotal: React.FC<TransactionsTotalsProps> = ({ total }) => {
  return (
    <Stack direction='column' alignItems='flex-end' sx={{ whiteSpace: 'nowrap' }}>
      <Typography variant='p30' color='secondary.main'>
        {formatDollars(total)}
      </Typography>
      <Typography variant='p16' color='secondary.main'>
        Total amt paid
      </Typography>
    </Stack>
  );
};

export const RevShareTotal: React.FC<TransactionsTotalsProps> = ({ total }) => {
  return (
    <Stack direction='column' alignItems='flex-end' sx={{ whiteSpace: 'nowrap' }}>
      <Typography variant='p30Bold' color='secondary.main'>
        {formatDollars(total)}
      </Typography>
      <Typography variant='p16' color='secondary.main'>
        Total share
      </Typography>
    </Stack>
  );
};

export const AmountPaidSubtotal: React.FC<TransactionsTotalsProps> = ({ total }) => {
  return (
    <Box display='flex' justifyContent='flex-end' alignItems='center' sx={{ whiteSpace: 'nowrap' }}>
      <Typography variant='p16' color='secondary'>
        Total
      </Typography>
      <Typography variant='p20SemiBold' color='secondary' sx={{ ml: 1 }}>
        {formatDollars(total)}
      </Typography>
    </Box>
  );
};

export const RevShareSubtotal: React.FC<TransactionsTotalsProps> = ({ total }) => {
  return (
    <Box display='flex' justifyContent='flex-end' alignItems='center' sx={{ whiteSpace: 'nowrap' }}>
      <Typography variant='p16' color='secondary'>
        Total
      </Typography>
      <Typography variant='p20Bold' color='secondary' sx={{ ml: 1 }}>
        {formatDollars(total)}
      </Typography>
    </Box>
  );
};
